export default __webpack_public_path__ + "static/desk-2f86f6ebe786dbbd925550773b0cad82.png";